/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WizardPlanTaskDto
 */
export interface WizardPlanTaskDto {
    /**
     * 
     * @type {string}
     * @memberof WizardPlanTaskDto
     */
    taskId: string;
    /**
     * Catalog trigger id for this plan line (required)
     * @type {string}
     * @memberof WizardPlanTaskDto
     */
    triggerId: string;
    /**
     * 1-based order within the plan
     * @type {number}
     * @memberof WizardPlanTaskDto
     */
    sequence: number;
}

/**
 * Check if a given object implements the WizardPlanTaskDto interface.
 */
export function instanceOfWizardPlanTaskDto(value: object): value is WizardPlanTaskDto {
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    if (!('triggerId' in value) || value['triggerId'] === undefined) return false;
    if (!('sequence' in value) || value['sequence'] === undefined) return false;
    return true;
}

export function WizardPlanTaskDtoFromJSON(json: any): WizardPlanTaskDto {
    return WizardPlanTaskDtoFromJSONTyped(json, false);
}

export function WizardPlanTaskDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WizardPlanTaskDto {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'],
        'triggerId': json['triggerId'],
        'sequence': json['sequence'],
    };
}

export function WizardPlanTaskDtoToJSON(json: any): WizardPlanTaskDto {
    return WizardPlanTaskDtoToJSONTyped(json, false);
}

export function WizardPlanTaskDtoToJSONTyped(value?: WizardPlanTaskDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'triggerId': value['triggerId'],
        'sequence': value['sequence'],
    };
}

